import { Typography } from "@mui/material"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { sendCustomEvent } from "../../../events/events"
import { resetSlice } from "../../../store/slices/c2cSlice"
import { resetSteps } from "../../../store/slices/routingSlice/routingSlice"
import { ButtonsContainer, ContentContainer, IconContainer, ScrollContainer, SourceDescription, StyledButton, TopContainer } from "./styled"
import IconBox from "../../../components/IconBox"
import UIIcon from "../../../components/UIIcon"
import { OPERATIONS_STATUS_DETAILS } from "../../../utils/operation"
import { OperationStatus } from "../../../api/interface"
import SBPIconNoExt from "../../../components/SBPIconNoExt"

const SbpOutcomeTransferError = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleQuitEvent = () => {
    sendCustomEvent({
      eventName: "quit",
    })
  }

  const handleButtonClick = () => {
    handleQuitEvent()
    dispatch(resetSlice())
    dispatch(resetSteps())
    navigate("/quit")
  }

  return (
    <ContentContainer>
      <ScrollContainer>
        <TopContainer>
          <IconBox size="lg" color="yellow">
              <UIIcon
                iconName={OPERATIONS_STATUS_DETAILS[OperationStatus.CREATE_ERROR].icon}
                size={80}
              />
            </IconBox>
            <SourceDescription>
              Запрос отклонен банком <br /> Получателя
            </SourceDescription>
            <Typography
              variant="subtitle1"
              sx={{ mt: "20px", color: "gray", lineHeight: 1.2 }}
            >
              Свяжитесь с Получателем перевода и <br /> уточните реквизиты для
              зачисления
              <br /> платежа
            </Typography>
        </TopContainer>
        <IconContainer>
          <SBPIconNoExt size={60} />
        </IconContainer>
      </ScrollContainer>
      <ButtonsContainer>
        <StyledButton
          variant="contained"
          color="secondary"
          onClick={handleButtonClick}
        >
          Закрыть
        </StyledButton>
      </ButtonsContainer>
    </ContentContainer>
  )
}

export default SbpOutcomeTransferError